import React from 'react';
import {
  Section,
  Container,
  Heading,
  //   Eyebrow,
  Title,
  Description,
  MarqueeWrapper,
  MarqueeTrack,
  BrandItem,
  BrandName,
  Dot,
  Note,
} from './Brands.styles';
import PrimaryButton from '../../../../Components/Buttons/PrimaryButton/PrimaryButton.component';

const brands = [
  '3M',
  'Milwaukee',
  'Honeywell',
  'Klein Tools',
  'Werner',
  'Pioneer',
  'Mechanix Wear',
  'Jackson Safety',
  'Sellstrom',
  'Moldex',
  'MSA Safety',
  'Ansell',
];

export default function TrustedBrands() {
  const repeatedBrands = [...brands, ...brands];

  return (
    <Section aria-labelledby="trusted-brands-title">
      <Container>
        <Heading>
          {/* <Eyebrow>Brands We Carry</Eyebrow> */}

          <Title id="trusted-brands-title">
            Trusted Products from Recognized Brands
          </Title>

          <Description>
            Access dependable safety equipment, tools, and workplace products
            from established manufacturers across the industry.
          </Description>
        </Heading>

        <MarqueeWrapper>
          <MarqueeTrack>
            {repeatedBrands.map((brand, index) => (
              <BrandItem
                key={`${brand}-${index}`}
                aria-hidden={index >= brands.length}
              >
                <BrandName>{brand}</BrandName>
                <Dot aria-hidden="true" />
              </BrandItem>
            ))}
          </MarqueeTrack>
        </MarqueeWrapper>

        <Note>
          Looking for a specific manufacturer or product? Contact our team and
          we’ll help you find the right option.
        </Note>

        <PrimaryButton
          functionName={() => (window.location.href = '/contact-us')}
          span="Ask About a Brand"
        />
      </Container>
    </Section>
  );
}
